export const STATUS_COLOR = {
  Preparando: ' #0D88FF',
  Cultivando: '#FFBB01',
  Despescado: ' #22296A',
  Transferido: ' #8E30FF',
  Concluído: '#44D788',
};

export interface IRenderAvailableOrMaintenance {
  value: string;
  weight: number;
  size: number;
}

type IParamFunctionOption = {
  route: string;
  data: {
    id: string | number;
    data: any; //TODO: review
  };
};
export interface IOptionsDropDown {
  title: string;
  onClick: (param: IParamFunctionOption) => void;
}

export type ParamFunc = {
  id: string | number;
  pond: any; //TODO: REVIEW
};
